import React, { useContext, useEffect, useLayoutEffect } from 'react';
// Components
import MetaDescription from '../components/Molecules/MetaDescription';
// Layouts
import { ChatContextControls } from '../components/modules/Yamb/components/Chat/ChatManager';
import Section from '../components/Molecules/Section/Section';
import { Heading } from '../components/Atoms/Heading';
import { Flex } from '../components/Atoms/Flex-Grid';
import { YambMainLink } from '../components/Pages/yamb.atoms';
import { Paragraph } from '../components/Atoms/Paragraph';
import { ArenaContext } from '../components/Context/ArenaContext';

function YambPage() {
	const { resetChat } = useContext(ChatContextControls);
	useLayoutEffect(() => {
		resetChat();
	}, [resetChat]);
	useEffect(() => {
		if (typeof window !== 'undefined') {
			window.sessionStorage.clear();
		}
	}, []);

	return (
		<>
			<MetaDescription
				page={{
					meta: {
						pageTitle: 'Play Yamb - The game',
						metaDescription: 'Online multiplayer Yamb (Yahtzee) game',
					},
				}}
			/>
			<Section>
				<Heading textAlign="center" fontWeight="normal" padding="bm txl">
					Play Yamb
				</Heading>
				<Flex direction="column" padding="bxxl" margin="bxxl">
					<YambMainLink
						href="/yamb/chose-game-type?mode=single"
						to="/yamb/chose-game-type?mode=single"
						padding="txs bxs"
					>
						Play alone
					</YambMainLink>
					<YambMainLink
						href="/yamb/chose-game-type?mode=multi"
						to="/yamb/chose-game-type?mode=multi"
						padding="txs bxs"
					>
						Play with a friend
					</YambMainLink>
					<YambMainLink
						href="/yamb/chose-game-type?mode=arena"
						to="/yamb/chose-game-type?mode=arena"
						padding="txs bxs"
						fontSize="h2"
						text_color="blue"
					>
						Arena
					</YambMainLink>
					<YambMainLink
						href="/yamb/hall-of-fame"
						to="/yamb/hall-of-fame"
						padding="txs bxs"
					>
						Hall of fame
					</YambMainLink>
					<YambMainLink
						href="/"
						to="/"
						padding="txs bxs"
					>
						Quit
					</YambMainLink>
					<ArenaContext.Consumer>
						{value => (
							<Paragraph fontSize="h6" textAlign="center" padding="tl">
								Online players:
								{value.onlinePlayers.length}
							</Paragraph>
						)}
					</ArenaContext.Consumer>
				</Flex>
			</Section>
		</>
	);
}

export default YambPage;
